import React from 'react';
type TickDividerProps = {
  className?: string;
};

/** Chapter-ring style section divider: hairline with minute and hour ticks. */
export function TickDivider({
  className = ''
}: TickDividerProps) {
  return <div role="presentation" className={`tick-rule ${className}`} data-id="element-470" data-mp="2cm1j2h8jfrzz" />;
}